import { connect } from 'react-redux';
import { Icon, Menu, Table } from 'semantic-ui-react';
import PageContainer from '../../common/PageContainer';
import * as actions from '../../../redux/actions';
import * as selectors from '../../../redux/selectors';
import { memo, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';

const EmailTemplateSearch = ({ getAllTemplates, templates }) => {
  useEffect(() => getAllTemplates(), []);

  const TableMemo = memo(() => (
    <Table size="small" compact="very" celled>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell collapsing>Description</Table.HeaderCell>
          <Table.HeaderCell collapsing>City</Table.HeaderCell>
          <Table.HeaderCell collapsing>Site</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {templates.map(t => (
          <Table.Row key={t.id}>
            <Table.Cell collapsing textAlign="left">
              <Link to={`/admin/email-template/edit/${t.id}`}>{t.description}</Link>
            </Table.Cell>
            <Table.Cell collapsing textAlign="left">
              <Link to={`/admin/email-template/edit/${t.id}`}>{t.site.city}</Link>
            </Table.Cell>
            <Table.Cell collapsing textAlign="left">
              <Link to={`/admin/email-template/edit/${t.id}`}>{t.site.property}</Link>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  ));

  const getPage = () => (
    <>
      <Menu borderless attached="top">
        <Menu.Item header>
          <Icon name="envelope outline" />
          Email templates
        </Menu.Item>

        {/* <Menu.Menu position="right">
          <Menu.Item>
            <Dropdown text="Actions" icon="chevron down" floating labeled button className="icon">
              <Dropdown.Menu>
                <Link to="/admin/email-template/add">
                  <Dropdown.Item content="Add email template" icon="plus" />
                </Link>
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Item>
        </Menu.Menu> */}
      </Menu>

      <TableMemo />
    </>
  );

  return <PageContainer>{getPage()}</PageContainer>;
};

const mapStateToProps = state => ({
  templates: selectors.getEmailTemplates(state),
});

const mapDispatchToProps = dispatch => ({
  getAllTemplates: bindActionCreators(actions.admin.getAllTemplates, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmailTemplateSearch);
